<template>
  <div>
    <wc-data-box :title='$store.state.icons.dataBox.payments.title'
      :titleIcon='$store.state.icons.dataBox.payments.icon'
      :titleIconColor='$store.state.icons.dataBox.payments.iconColor' :loading='isLoading'
      :showAdd='!invoice.archived && !invoice.is_uncollectible && invoice.is_posted' @add='addPayment'>
      <v-simple-table dense>
        <thead>
          <tr class='overline'>
            <th width='120'>Date</th>
            <th>Pmt Method</th>
            <th width='100'>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if='payments.length === 0'>
            <td colspan='3'>No payments...</td>
          </tr>
          <tr v-else v-for='p in payments' :key='p.id' @click='editPayment(p)'>
            <td>{{ p.date_paid | shortDate }}</td>
            <td>{{ p.payment_method_display }}</td>
            <td class='text-right'>{{ p.amount | decMoney }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

    <wc-dialog :showDialog='show_new_payment' title='Payment' :icon='$store.state.icons.dataBox.payments.icon'
      :iconColor='$store.state.icons.dataBox.payments.iconColor' :disableButtons='!isFormValid' :loading='isSaving'
      :loadingButtons='isSaving' width='400' @cancel='resetPaymentForm' @save='createPayment'>
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <wc-datepicker label='Date' v-model='paymentCopy.date_paid' required></wc-datepicker>
          </v-col>
          <v-col cols='6'>
            <v-select label='Payment method' :items='filteredPaymentTypes' v-model='paymentCopy.payment_method'
              :rules='[rules.required]'></v-select>
          </v-col>
          <v-col cols='6'>
            <v-text-field reverse prepend-icon='mdi-currency-usd' v-model='paymentCopy.amount'
              :rules='[rules.decimal]'></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
    <wc-dialog :showDialog='show_update_payment' title='Payment' :icon='$store.state.icons.dataBox.payments.icon'
      :iconColor='$store.state.icons.dataBox.payments.iconColor' :disableButtons='!isFormValid' :loading='isSaving'
      :loadingButtons='isSaving' width='400' @cancel='resetPaymentForm' @save='updatePayment'>
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <wc-datepicker label='Date' v-model='paymentCopy.date_paid' required></wc-datepicker>
          </v-col>
          <v-col cols='6'>
            <v-select label='Payment method' :items='filteredPaymentTypes' v-model='paymentCopy.payment_method'
              :rules='[rules.required]'></v-select>
          </v-col>
          <v-col cols='6'>
            <v-text-field reverse prepend-icon='mdi-currency-usd' v-model='paymentCopy.amount'
              :rules='[rules.decimal]'></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <template v-slot:dialog-actions v-if='paymentCopy.id !== null'>
        <v-btn text @click='showConfirmDelete = true' color='error'>Delete Payment</v-btn>
      </template>
    </wc-dialog>

    <wc-dialog :showDialog='showConfirmDelete' title='Are you sure?' icon='mdi-alert' iconColor='error'
      saveText='Yes, Delete It' @cancel='showConfirmDelete = false' @save='deletePayment' :loading='isSaving'
      :loadingButtons='isSaving' width='350'>
      Are you sure you want to delete this payment?
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules';
import moment from 'moment';
import _ from 'lodash';
import accountingAPI from '@/api/accounting';
import trackerAPI from '@/api/tracker';

export default {
  name: 'invoice-payments',
  mixins: [formRules],
  props: {
    invoice: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    show_new_payment: false,
    show_update_payment: false,
    showDialog: false,
    showConfirmDelete: false,
    payments: [],
    paymentCopy: {
      id: null
    }
  }),
  mounted() {
    this.getData();
  },
  computed: {
    filteredPaymentTypes() {
      return _.filter(this.$store.state.misc.globalOptions.paymentTypes, pt => pt.value != "V");
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.payments = await accountingAPI.getInvoicePayments(this.invoice.id);
      this.isLoading = false;
    },
    resetPaymentForm() {
      this.$refs.form.reset();
      this.paymentCopy = { id: null }
      this.show_new_payment = false;
      this.show_update_payment = false;
    },
    addPayment() {
      this.paymentCopy.invoice = this.invoice.id;
      this.paymentCopy.date_paid = moment().format('YYYY-MM-DD').toString();
      this.paymentCopy.payment_method = 'C';
      this.paymentCopy.amount = this.invoice.amount_os;
      this.show_new_payment = true;
    },
    editPayment(pmt) {
      this.paymentCopy = _.cloneDeep(pmt);
      this.show_update_payment = true;
    },
    async createPayment() {
      this.isSaving = true;
      const newPayment = await accountingAPI.createInvoicePayment(this.paymentCopy);
      this.payments.push(newPayment);
      this.recordAction('Received payment of $' + this.$options.filters.dec(newPayment.amount) + ' by ' + newPayment.payment_method_display);
      this.resetPaymentForm();
      this.$emit('updatePayments', -newPayment.amount);
      this.isSaving = false;
      this.show_new_payment = false;
    },
    async updatePayment() {
      const newPayment = await accountingAPI.updateInvoicePayment(this.paymentCopy.id, this.paymentCopy);
      let payment_amount = 0;
      this.payments.map(payment => {
        if (payment.id === newPayment.id) {
          const index = this.payments.indexOf(payment);
          payment_amount = payment.amount - this.paymentCopy.amount;
          this.payments.splice(index, 1, newPayment);
        }
      });
      this.recordAction('Edited payment to be $' + this.$options.filters.dec(newPayment.amount));
      this.$emit('updatePayments', payment_amount);
      this.resetPaymentForm();
      this.isSaving = false;
      this.show_update_payment = false;
    },
    async deletePayment() {
      this.isSaving = true;
      let payment_amount = 0;
      this.payments.map(payment => {
        if (payment.id === this.paymentCopy.id) {
          const index = this.payments.indexOf(payment);
          payment_amount = payment.amount;
          this.payments.splice(index, 1);
        }
      });
      await accountingAPI.deleteInvoicePayment(this.paymentCopy.id);
      this.recordAction('Deleted payment of $' + this.$options.filters.dec(this.paymentCopy.amount));
      this.showConfirmDelete = false;
      this.resetPaymentForm();
      this.$emit('updatePayments', payment_amount);
      this.isSaving = false;
    },
    async recordAction(action) {
      const tracker_data = {
        'description': action,
        'taken_by': this.$store.state.auth.profile.id,
        'action_date': moment().format('YYYY-MM-DD').toString()
      }
      const tracker = {
        'tracker_data': tracker_data,
        'invoice': this.invoice.id
      }
      const res = await trackerAPI.createInvoiceTracker(tracker);
      this.$emit('newAction', res);
    }
  }
}
</script>
